import { QueryClient, QueryClientProvider } from '@tanstack/solid-query'
import { render } from 'solid-js/web'
import { App } from './app.tsx'
import { ReadOnlyError } from './lib/read-only.ts'
import { showToast, ToastRegion } from './ui/index.ts'
import './index.css'

window.addEventListener('error', (event) => {
  if (event.error instanceof ReadOnlyError) {
    event.preventDefault()
    showToast(event.error.message, 'error')
  }
})
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason instanceof ReadOnlyError) {
    event.preventDefault()
    showToast(event.reason.message, 'error')
  }
})

const root = document.getElementById('root')
if (!root) throw new Error('Missing root element')
const client = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: true } },
})
render(
  () => (
    <QueryClientProvider client={client}>
      <App />
      <ToastRegion />
    </QueryClientProvider>
  ),
  root,
)
